module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n    "), (_vm.perscription !== 0) ? _c('span', {
    staticClass: "float-right"
  }, [_vm._v("處方籤數量: " + _vm._s(_vm.perscription))]) : _vm._e()]), _vm._v(" "), (_vm.currentProgress === 'setFetchNum') ? _c('ConfirmStorage', {
    attrs: {
      "defaultAmount": _vm.defaultAmount,
      "inputLabel": '處方籤數量'
    },
    on: {
      "setNum": _vm.getStorageAmount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'MedIdInput') ? _c('MedIdInput', {
    attrs: {
      "inputLabel": _vm.textInpuTitle
    },
    on: {
      "setText": _vm.getMedId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('rx-check-barcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "startActionType": _vm.startActionType,
      "actionProgress": _vm.actionProgress,
      "medRecordId": _vm.medRecordId,
      "barcodeData": _vm.barcodeData,
      "reviewer": _vm.reviewer,
      "amount": _vm.perscription
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c747519","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugFlow/ConfirmFlow.vue
// module id = 1420
// module chunks = 1